import axios from 'axios';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Footer from '../components/Footer';
import List from '../components/List';
import ListWisata from '../components/List/ListWisata';
import Navbar from '../components/Navbar';

export default function WisataBudaya() {
  const [events, setEvents] = useState('');

  useEffect(() => {
    axios.get('http://localhost:3004/events').then((res) => {
      setEvents(res.data);
      console.log(res.data);
    });
  }, []);
  return (
    <div>
      <div className="container mx-auto px-[4%]">
        <Navbar />
        <div className="relative flex justify-center items-center mb-20">
          <img src="/assets/images/landing-page.png" alt="landing-page" />
          <div className="absolute flex flex-col items-center lg:top-[30%] md:top-[20%] top-[15%]">
            <p className="lg:text-4xl sm:text-lg text-base text-white text-center font-bold md:w-[60%] w-[60%]">
              Yuk, Jelajahi Kebergaman Wisata dan Budaya Tegal
            </p>
            <p className="lg:text-xl sm:text-sm text-xs text-secondary text-center md:w-[40%] w-[60%]">
              Tegal memiliki berbagai keberagaman wisata dan budaya yang sangat sayang untuk
              dilewatkan
            </p>
          </div>
        </div>
        <List />
        <ListWisata data={events} />
      </div>
      <Footer />
    </div>
  );
}
